export default {
    finger: 'https://storage.googleapis.com/conversional_production/files/filestore/file/7765/finger.svg',
    face: 'https://storage.googleapis.com/conversional_production/files/filestore/file/7766/face.svg',
};
